import React from 'react'
import styled from 'styled-components'
import CarpartsPlusWmo from '@usap/uicomponents/src/components/Icons/wmo-icons/CarpartsPlusWmo'
import useLoyaltyEnabled from '../../hooks/useLoyaltyEnabled'
import { CP_PLUS_GOLD_LOGO_URL } from './constants'

const StyledContainer = styled.div`
  display: flex;
  height: 28px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3.5px;
  align-self: stretch;

  border-radius: 3.5px;
  background: #D4F4FF;
`

const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 1.75px 7px;

  > span {
    display: flex;
    width: 100%;
    height: 13.125px;
    flex-direction: column;
    justify-content: center;
    color: var(--CTA-Button-Primary-Text, #282832);
    text-align: center !important;
    font-family: Roboto;
    font-size: 10.5px !important;
    font-style: normal;
    font-weight: 600;
    line-height: 165%; /* 17.325px */
  }

  svg {
    display: flex;
    align-items: flex-start;
    gap: 1.643px;
  }
`

const StyledGoldContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  padding: 3.5px 4px;
  border-radius: 3.5px;
  background: #D4F4FF;
  white-space: nowrap;
  justify-content: center;
  align-self: stretch;
`

const StyledGoldText = styled.div`
  display: flex;
  flex-direction: column;
  font-style: italic;
  font-weight: 600;
  font-size: 10px;
  line-height: 115%;
  color: #111F30;

  > span {
    font-style: italic !important;
    font-weight: 600 !important;
    font-size: 10px !important;
    line-height: 115% !important;
    letter-spacing: 0% !important;
  }
`

export const FreeShippingMembershipV2 = ({ sku }) => {
  const isLoyaltyEnabled = useLoyaltyEnabled()

  if (isLoyaltyEnabled) {
    return (
      <StyledGoldContainer
        id={`free-shipping-membership-${sku}`}
        data-testid="freeshipping-membership"
      >
        <img src={CP_PLUS_GOLD_LOGO_URL} width={20} height={20} alt="CarParts+ Gold" style={{ objectFit: 'contain', width: '20px', height: '20px', minHeight: 'unset', maxWidth: 'unset' }} />
        <StyledGoldText>
          <span>Ships Free with</span>
          <span>CarParts+ Gold</span>
        </StyledGoldText>
      </StyledGoldContainer>
    )
  }

  return (
    <StyledContainer>
      <StyledContentWrapper
        id={`free-shipping-membership-${sku}`}
        data-testid="freeshipping-membership"
      >
        <span>
          Ships Free with
        </span>
        <CarpartsPlusWmo width={56} height={10} />
      </StyledContentWrapper>
    </StyledContainer>
  )
}
